export default __webpack_public_path__ + "assets/circle-icon-labExam-component.3dd68f01.svg";